import React from "react";

function IconDesplegarMenu() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="11"
            fill="none"
            viewBox="0 0 19 11"
        >
            <path
                fill="#F28E2A"
                fillRule="evenodd"
                d="M1.196 1.25a1.1 1.1 0 011.555-.054l6.749 6.3 6.75-6.3a1.1 1.1 0 111.5 1.608l-7.5 7a1.1 1.1 0 01-1.5 0l-7.5-7a1.1 1.1 0 01-.054-1.555z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default IconDesplegarMenu;
